import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IBaseWorkflowData, type IFullWorkflowData } from 'entities/Workflow/api'
import { transformWorkflowV1UISettingsToV2 } from 'entities/Workflow/utils/transformWorkflowV1UISettingsToV2'

export class WorkflowRow extends RowBase<IFullWorkflowData> {
  constructor(origin: IFullWorkflowData) {
    super(origin)
    makeObservableRowBase(this)
  }

  get workflow() {
    return this
  }

  get id() {
    return this.origin.id
  }

  get name() {
    return this.origin.name
  }

  get enabled() {
    return this.origin.enabled
  }

  get createdAt() {
    return this.origin.created_at
  }

  get updatedAt() {
    return this.origin.updated_at
  }

  get executionsCount() {
    return this.origin.executions_count
  }

  get isInvalid() {
    return this.origin.is_invalid
  }

  get v2Data() {
    if (this.origin.ui_settings?.data) {
      return transformWorkflowV1UISettingsToV2(this.origin.ui_settings?.data.children ?? null)
    }

    return {
      definition: this.origin.definition,
      ui_settings: this.origin.ui_settings,
    }
  }

  get baseData(): IBaseWorkflowData {
    return {
      name: this.origin.name,
      enroll_by_webhook: this.origin.enroll_by_webhook,
      webhook_url: this.origin.webhook_url,
      multiple_executions: this.origin.multiple_executions,
      description: this.origin.description,
      settings: this.origin.settings ?? null,
      ...this.v2Data,
    }
  }
}
